import { Stack } from "react-bootstrap";

type StatusMessageProps = {
  error?: boolean;
  message: string;
}

const StatusMessage = ({ error, message }: StatusMessageProps) => {
  const messageParts = message.split("\n");
  const classes = error ? "text-danger" : "";
  
  return (
    <Stack className="mb-3">
      {messageParts.map((part: string, index: number) => {
        const content = part.startsWith("http") ? (<a href={part}>{part}</a>) : part;
        return (
          <p key={index} className={classes}>{content}</p>
        );
      })}
    </Stack>
  );
}

export default StatusMessage;